import { ModalWindow } from '@cian/ui-kit/modal';
import { forwardRef, useEffect, useState } from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { useAuthorization } from '../../hooks/useAuthorization';
import { PhoneWindow } from './PhoneWindow';
import { SmsWindow } from './SmsWindow';

type AuthWindowProps = {
  onAuth: (advertisingAgreement?: boolean) => void;
  handleShowScreens: (isSmsWindowShows: boolean) => void;
  handleCloseModal: () => void;
};

export const AuthWindow = forwardRef<HTMLDivElement, AuthWindowProps>(function AuthWindow(props, ref) {
  const context = useApplicationContext();
  const { phoneInputDescription } = context.custom;
  const { onAuth, handleShowScreens, handleCloseModal } = props;

  const [isOpen, setIsOpen] = useState(true);

  const {
    phone,
    setPhone,
    uuid,
    codeError,
    setCodeError,
    setShowAgreements,
    advertisingAgreement,
    setAdvertisingAgreement,
    code,
    setCode,
    maskedPhone,
    handleSendPhone,
    handleResetPhone,
    handleSendCode,
  } = useAuthorization({ onAuth, onCloseModal: () => setIsOpen(false) });

  function handleCloseModalWindow() {
    handleCloseModal();
    setIsOpen(false);
  }

  const showSmsWindow = maskedPhone !== null && uuid !== null;

  useEffect(() => {
    handleShowScreens(showSmsWindow);
  }, [handleShowScreens, showSmsWindow]);

  const modalWindowTitle = showSmsWindow ? 'Введите код из смс' : 'Войти или зарегистрироваться';
  const modalWindowContent = showSmsWindow ? (
    <SmsWindow
      uuid={uuid}
      phone={maskedPhone}
      code={code}
      codeError={codeError}
      agreementsChecked={advertisingAgreement}
      setCode={setCode}
      setCodeError={setCodeError}
      onResetPhone={handleResetPhone}
      onEnterCode={handleSendCode}
      onResendPhone={handleSendPhone}
      onShowAgreements={() => setShowAgreements(true)}
      setAgreementsChecked={setAdvertisingAgreement}
    />
  ) : (
    <PhoneWindow
      phone={phone}
      maskedPhone={maskedPhone}
      changePhone={setPhone}
      handleSendPhone={handleSendPhone}
      inputDescription={
        phoneInputDescription ?? 'Номер нужен, чтобы отправить смс с решениями от банков — спамить не будем'
      }
    />
  );

  return (
    <div ref={ref}>
      <ModalWindow
        open={isOpen}
        title={modalWindowTitle}
        content={modalWindowContent}
        width={498}
        onClose={handleCloseModalWindow}
      />
    </div>
  );
});
